export const last = items => (items ? items[items.length - 1] : null)

export default last